import { Text } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

export const EmploymentPeriodText = ({ startDate, endDate }: { startDate: string; endDate?: string | null }) => {
  const { t } = useTypedTranslation();
  return (
    <Text color="black60">
      {endDate
        ? startDate + ' - ' + endDate
        : t('section.employmentDetails.employmentPeriodOngoing', { date: startDate })}
    </Text>
  );
};
